class CategoriesController {
  constructor() {
    this.name = 'categories';
  }
}

export default CategoriesController;


// WEBPACK FOOTER //
// ./client/app/components/categories-faq/categories.controller.js